import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function HorizontalBarChart({ title, labels, dataValues, color = '#4c84ff' }) {
  const data = {
    labels,
    datasets: [
      { label: title, data: dataValues, backgroundColor: color, borderRadius: 6, barThickness: 12 },
    ],
  };
  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: { x: { beginAtZero: true } },
  };
  return (
    <div style={{ height: 200 }}>
      <Bar data={data} options={options} />
    </div>
  );
}

export default HorizontalBarChart;


